import apiSlice from "./apiSlice";

export interface Platform { 
    id: number, 
    name: string
}

export interface GetPlatformResponse {
    success: boolean
    message: string
    platforms: Platform[];
}

export const platformsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPlatforms: builder.query<GetPlatformResponse, void>({
            query: () => ({
                url: '/bets/platforms',
                method: 'GET',
            }),
            providesTags: ['Platforms'],
        }),
    
    })
})

export const {useGetPlatformsQuery} = platformsApi